export default "__VITE_ASSET__Dxx1gpWi__"